import React from 'react';
import { Box, SxProps, Tooltip } from '@mui/material';
import { CustomAvatar } from '@europrocurement/flexy-components';

type PeoplePreviewProps = {
    firstName?: string;
    lastName?: string;
    userIdentifier?: string;
    sx?: SxProps;
    sxAvatar?: SxProps;
    tooltipTitle?: string;
    onClick?: (e: React.MouseEvent) => void;
};

const PeoplePreview: React.FunctionComponent<PeoplePreviewProps> = function (props) {
    const {
        firstName,
        lastName,
        userIdentifier,
        sx = {},
        sxAvatar = {},
        onClick = () => {},
        tooltipTitle,
    } = props;

    if (!firstName && !lastName) {
        return null;
    }

    const boxStyle = {
        borderRadius: '16px',
        width: '32px',
        height: '32px',
        margin: '0px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
    };

    return (
        <Tooltip title={tooltipTitle || `${firstName} ${lastName}`}>
            <Box sx={boxStyle}>
                <CustomAvatar
                    sx={{
                        width: '32px',
                        height: '32px',
                        ...sxAvatar,
                    }}
                    firstName={firstName}
                    lastName={lastName}
                    keycloakId={userIdentifier}
                    onClick={onClick}
                />
            </Box>
        </Tooltip>
    );
};

export default PeoplePreview;
